/**
 * Schedule-a-Demo iframe. The booking page scrolls inside the frame; on a
 * phone that paints a classic gutter scrollbar (Windows Chrome / device
 * toolbar). Clip that gutter on narrow + fine-pointer viewports. Touch
 * overlay scrollbars do not take a gutter, so they are left alone.
 */
export function DemoBookingEmbed({
  src,
  title = 'Schedule a Demo',
}: {
  src: string;
  title?: string;
}) {
  return (
    <div
      data-testid="demo-booking-embed"
      className="relative min-h-0 flex-1 overflow-hidden"
    >
      <iframe
        src={src}
        title={title}
        className="absolute left-0 top-0 h-full w-full border-0 [@media(hover:hover)_and_(pointer:fine)]:max-md:w-[calc(100%+16px)]"
      />
    </div>
  );
}
